import { MenuItem } from "@mui/material"
import { ReactElement } from "react"

import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Order } from "../../../controlKitchenTypes"

type MenuActionKey = "showReceipt" | "refund" | "messageCustomer"

type MenuItemConfig = {
    key: MenuActionKey
    element: ReactElement
}

type OrderAccountingMenuProps = Readonly<{
    order: Order
    onShowReceipt: (order: Order) => void
    onMessageCustomer?: (order: Order) => void
    onClose: () => void
    onRefund: (order: Order) => void
}>

export function OrderAccountingMenu({
    order,
    onShowReceipt,
    onMessageCustomer,
    onClose,
    onRefund,
}: OrderAccountingMenuProps) {
    const handleShowReceipt = () => {
        onShowReceipt(order)
        onClose()
    }

    const handleRefundClick = () => {
        onRefund(order)
        onClose()
    }

    const handleMessageCustomer = () => {
        onMessageCustomer?.(order)
        onClose()
    }

    const menuItemsConfig: MenuItemConfig[] = [
        {
            key: "showReceipt",
            element: (
                <LocalizedStrict id="office-purchase-receipt" key={`receipt-${order.id}`}>
                    <MenuItem onClick={handleShowReceipt}>Receipt</MenuItem>
                </LocalizedStrict>
            ),
        },
        {
            key: "refund",
            element: (
                <LocalizedStrict id="order-action-menu-refund" key={`refund-${order.id}`}>
                    <MenuItem onClick={handleRefundClick}>Refund</MenuItem>
                </LocalizedStrict>
            ),
        },
        {
            key: "messageCustomer",
            element: (
                <LocalizedStrict id="transactions-table-list-message-customer" key={`message-customer-${order.id}`}>
                    <MenuItem onClick={handleMessageCustomer}>Message customer</MenuItem>
                </LocalizedStrict>
            ),
        },
    ]

    const menuItems = menuItemsConfig
        .filter(({ key }) => {
            if (key === "refund") return order.orderAction?.refundPOSOrder !== undefined
            if (key === "messageCustomer") return onMessageCustomer !== undefined
            return true
        })
        .map(({ element }) => element)

    return <>{menuItems}</>
}
